import { BooleanInput, DateInput, EditBase, FormDataConsumer, required, SelectInput, TextInput } from "react-admin";
import { approvalStatusChoices } from "../../model/approvalStatusChoices";
import { ExaminationAssignmentReceivedAtInput } from "../../inputs/ExaminationAssignmentExpiresAtInput";
import { ExaminationAssignmentExpiresAtInput } from "../../inputs/ExaminationAssignmentReceivedAtInput";
import { DialogActions, DialogContent } from "@mui/material";
import { Form2 } from "../../misc/Form2";
import { SaveButton2 } from "../../buttons/SaveButton2";
import { date, dateMinYear, dateNotInTheFuture } from "../../utils/validators";
import { ExamEligibilityInfo } from "./ExamEligibilityInfo";

export function StudentAdministrativeOnboardingForChangersForm({ onSave }: { onSave: () => void }) {
  return (
    <EditBase redirect={false} mutationMode="pessimistic" mutationOptions={{ onSuccess: onSave }}>
      <Form2 shouldUnregister>
        <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
          <FormDataConsumer>
            {({ formData }) => {
              if (formData.administrativeOnboardingForChangersState?.changeApproved === "pending") {
                return (
                  <>
                    <BooleanInput
                      label="Alte Fahrschule gekündigt"
                      source="administrativeOnboardingForChangersState.oldContractTerminated"
                    />
                    <BooleanInput
                      label="Ausbildungsnachweis liegt vor"
                      source="administrativeOnboardingForChangersState.trainingCertificateSent"
                    />
                    <BooleanInput
                      label="Bei Behörde angezeigt"
                      source="administrativeOnboardingForChangersState.changeSubmitted"
                    />
                    <DateInput
                      sx={{ width: "15em" }}
                      size="small"
                      label="Antrag abgegeben am"
                      source="administrativeOnboardingForChangersState.changeSubmittedAt"
                      validate={[date(), dateMinYear(2000), dateNotInTheFuture()]}
                    />
                  </>
                );
              }
            }}
          </FormDataConsumer>
          <TextInput
            sx={{ width: "15em" }}
            defaultValue=""
            label="Antragsnummer"
            source="administrativeOnboardingForChangersState.applicationNumber"
            parse={(value) => (value === "" ? "" : value)}
          />
          <SelectInput
            sx={{ width: "15em" }}
            label="Status"
            source="administrativeOnboardingForChangersState.changeApproved"
            choices={approvalStatusChoices}
            validate={required()}
          />
          <FormDataConsumer>
            {({ formData }) =>
              formData.administrativeOnboardingForChangersState.changeApproved === "approved" && (
                <>
                  <ExaminationAssignmentReceivedAtInput />
                  <ExaminationAssignmentExpiresAtInput />
                </>
              )
            }
          </FormDataConsumer>
          <ExamEligibilityInfo />
        </DialogContent>
        <DialogActions>
          <SaveButton2 />
        </DialogActions>
      </Form2>
    </EditBase>
  );
}
